/**
 * @generated SignedSource<<3bfad21e05ba3601b1e7cb3d60333849>>
 * @relayHash 353c750d1d9c07e8abdb4550c228baa8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 353c750d1d9c07e8abdb4550c228baa8

import { ConcreteRequest } from 'relay-runtime';
export type De_deleteProgressNoteInput = {
  id: string;
};
export type deDeleteProgressNoteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: De_deleteProgressNoteInput;
};
export type deDeleteProgressNoteMutation$data = {
  readonly deleteProgressNote: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly progressNote: {
      readonly id: string;
    } | null;
  };
};
export type deDeleteProgressNoteMutation = {
  response: deDeleteProgressNoteMutation$data;
  variables: deDeleteProgressNoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deDeleteProgressNoteMutation",
    "selections": [
      {
        "alias": "deleteProgressNote",
        "args": (v2/*:: as any*/),
        "concreteType": "De_deleteProgressNotePayload",
        "kind": "LinkedField",
        "name": "de_deleteProgressNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "progressNote",
            "args": null,
            "concreteType": "de_ProgressNote",
            "kind": "LinkedField",
            "name": "de_ProgressNote",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deDeleteProgressNoteMutation",
    "selections": [
      {
        "alias": "deleteProgressNote",
        "args": (v2/*:: as any*/),
        "concreteType": "De_deleteProgressNotePayload",
        "kind": "LinkedField",
        "name": "de_deleteProgressNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "progressNote",
            "args": null,
            "concreteType": "de_ProgressNote",
            "kind": "LinkedField",
            "name": "de_ProgressNote",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "353c750d1d9c07e8abdb4550c228baa8",
    "metadata": {},
    "name": "deDeleteProgressNoteMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "40092416b637f53ed0085121f46e6fa7";

export default node;
